import { EntityTypes } from 'constants/entities';
import { getRequest } from 'core/services/admin';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { useCallback, useEffect } from 'react';

const recentRequests = new Map<string, number>();
const DEDUPE_WINDOW_MS = 750;

/**
 * @param skip pass true when the store already holds the entity and does not need
 *   re-fetching. Re-evaluated when it changes, so a caller can start out skipping and
 *   fetch later (or vice versa).
 */
export function useGet(type: EntityTypes, id?: number, skip?: boolean) {
  const state = useAppSelector(state => state[type]);
  const dispatch = useAppDispatch();

  const fetchData = useCallback(() => {
    const entityId = id ?? state?.id;
    const requestKey = `${type}:${entityId ?? 'all'}`;
    const now = Date.now();
    const lastRequestedAt = recentRequests.get(requestKey);

    if (lastRequestedAt && now - lastRequestedAt < DEDUPE_WINDOW_MS) return;

    recentRequests.set(requestKey, now);

    dispatch(
      getRequest({
        type,
        ...(entityId ? { entityId } : {}),
      }),
    );
  }, [dispatch, id, state?.id, type]);

  useEffect(() => {
    if (skip) return;

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, skip]);
}
